module.exports = __webpack_public_path__ + "static/media/UNM.71df5ac2.png";